import React from "react";
import { Container, Row, Col, Card, Accordion, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// import screenshots
import reportsHistory1 from "../../assets/img/docs/reports-23.png";
import reportsHistory2 from "../../assets/img/docs/reports-22.png";

const Section = ({
  eventKey,
  title,
  description,
  bullets = [],
  images = [],
}) => (
  <Accordion.Item
    eventKey={eventKey}
    className="mb-3 border-0 shadow-sm rounded section-item"
  >
    <Accordion.Header className="fw-semibold fs-6">{title}</Accordion.Header>
    <Accordion.Body className="pt-3 section-body">
      {description && <p className="mb-3 text-muted">{description}</p>}

      {bullets?.length > 0 && (
        <ul className="section-list mb-3">
          {bullets.map((b, i) => (
            <li key={i} className="mb-2">
              {b}
            </li>
          ))}
        </ul>
      )}

      {images?.length > 0 && (
        <Row className="g-3 mt-2">
          {images.map(
            (src, i) =>
              src && (
                <Col md={6} key={i}>
                  <Image
                    src={src}
                    alt={`${title} screenshot ${i + 1}`}
                    className="section-image"
                    rounded
                    fluid
                  />
                </Col>
              )
          )}
        </Row>
      )}
    </Accordion.Body>
  </Accordion.Item>
);

const ReportsHistoryDocs = () => {
  const { t } = useTranslation();

  const sections = [
    {
      key: "reportHistory",
      images: [reportsHistory1, reportsHistory2],
    },
  ];

  return (
    <Container fluid className="py-5 reports-history-docs">
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              <Card.Title className="display-6 mb-3">
                {t("documentation.reports.history.title")}
              </Card.Title>
              <Card.Text className="text-muted mb-3">
                {t("documentation.reports.history.description")}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col lg={10}>
          <Card className="shadow-sm border-0 rounded-lg p-3">
            <Accordion defaultActiveKey="0" alwaysOpen>
              {sections.map((s, idx) => {
                const bullets = t(
                  `documentation.reports.history.${s.key}.bullets`,
                  { returnObjects: true, defaultValue: [] }
                );

                return (
                  <Section
                    key={s.key}
                    eventKey={String(idx)}
                    title={t(
                      `documentation.reports.history.${s.key}.title`,
                      ""
                    )}
                    description={t(
                      `documentation.reports.history.${s.key}.description`,
                      ""
                    )}
                    bullets={Array.isArray(bullets) ? bullets : []}
                    images={s.images}
                  />
                );
              })}
            </Accordion>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ReportsHistoryDocs;
